import { Instagram } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { INSTAGRAM_URL } from "@/lib/social";

/**
 * Bas de pied de page, identique sur l'accueil et sur les pages internes :
 * mention de droits, lien social, signature.
 */
export const FooterBottom = () => {
  const { t } = useLanguage();
  return (
    <div className="mt-10 pt-8 border-t border-ink/5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="flex items-center gap-3">
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-link-instagram"
          aria-label={t("footer.instagram")}
          title={t("footer.instagram")}
          // Une boîte de 44 px porte le clic sans rien ajouter à l'écran, et la
          // marge négative ramène le pictogramme au bord du pied de page, à
          // l'aplomb du logo. Une cible de 20 px ne se vise pas au doigt.
          className="-ml-[13px] inline-flex h-11 w-11 shrink-0 items-center justify-center text-ink-subtle hover:text-gold-ink transition-colors duration-300"
        >
          <Instagram size={18} strokeWidth={1.5} aria-hidden="true" />
        </a>
        <p className="text-xs text-ink-subtle tracking-wide">
          © {new Date().getFullYear()} {t("footer.rights")}
        </p>
      </div>
      <p className="font-serif italic text-sm text-gold-ink">
        {t("footer.signature")}
      </p>
    </div>
  );
};

export default FooterBottom;
